<template>
	<div class="w-full h-full">
		<NewDatatable
			v-model="attendances"
			:headers="headers"
			:checkbox="false"
			empty-text="NÃO HÁ REGISTROS NO PRONTUÁRIO"
			:row-colors="{
				pending: 'var(--priorityBackgroundColor)',
				ready: 'var(--successBackgroundColor)',
			}"
			@click="OpenModalReport"
		>
			<template #row="{ item }">
				<div class="datatable-cell date">
					<b>
						{{ item.date }}
					</b>
				</div>
				<!-- <div class="datatable-cell time">
					<b>
						{{ item.time }}
					</b>
				</div> -->
				<div class="datatable-cell name">
					<b>{{
						item.proceeding_name ?? 'SEM PROCEDIMENTO VINCULADO'
					}}</b>
				</div>
				<div
					class="datatable-cell status"
					:class="item.status"
				>
					<b>{{ item.status_description.toUpperCase() }}</b>
				</div>
				<div class="datatable-cell actions">
					<button
						v-if="item.dicom_images_url"
						v-tippy="{ arrow: true }"
						content="Visualizar Imagens DICOM"
						class="btn btn-light-info px-3 py-2 mx-2"
						@click.stop="OpenExternalLink(item.dicom_images_url)"
					>
						<i class="m-1 fal fa-file-image font-20"></i>
					</button>
				</div>
			</template>
		</NewDatatable>

		<!-- MODAL LAUDO -->
		<div
			id="report-modal"
			class="modal fade"
		>
			<div class="modal-dialog">
				<div class="modal-content p-3 d-flex">
					<div class="align-self-end">
						<button
							id="close-modal"
							class="btn btn-light btn-sm m-2"
							@click="CloseModal('#report-modal')"
						>
							<i class="fal fa-times"></i>
						</button>
					</div>
					<div class="modal-header mb-4">
						<h3 class="m-0 text-center">Visualização do laudo</h3>
					</div>
					<div
						ref="report_content"
						class="modal-body d-flex justify-content-center"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const _ = require('lodash')
	import Swal from 'sweetalert2'
	import { mapActions, mapGetters } from 'vuex'

	import DataTables from '../../shared/DataTables'

	const FINISHED_STATUS = 8

	export default {
		name: 'History',
		components: {
			DataTables,
		},
		props: {
			patient: {
				type: Object,
				required: true,
				default: null,
			},
		},
		data() {
			return {
				is_load: false,
				history: null,
				app_url: process.env.VUE_APP_APP_URL,
				report_url: '',
				ended_report: '',
				report_code: '',
				headers: [
					{ text: 'DATA', value: 'data', width: '7rem' },
					// { text: 'HORA', value: 'hora', width: '5rem' },
					{ text: 'PROCEDIMENTO', value: 'proceeding' },
					{
						text: 'STATUS',
						value: 'status_description',
						width: '14rem',
					},
					{
						text: 'AÇÕES',
						value: 'actions',
						width: '8rem',
					},
				],
				timeline_data: {
					patient: {},
					logs: [],
					journey_id: null,
					scheduling_id: null,
				},
				sortedBy: {
					column: 'data',
					direction: 'DESC',
					icon: 'fa-chevron-down',
				},
				selected_attendance_id: null,
				attendances: [],
				FINISHED_STATUS,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			OpenExternalLink(link) {
				window.open(link, '_blank')
			},
			GetPatientAttendances() {
				const vm = this

				vm.StartLoading()

				vm.attendances = []

				return window.api
					.call('post', '/get-attendances', {
						account_id: vm.requester_selected_id,
						patient_id: vm.patient.id,
						light_data: true,
						latest_first: true,
					})
					.then(({ data }) => {
						if (data.response) {
							vm.attendances = data.attendances.map(
								attendance => {
									attendance.status_description =
										attendance.status ===
										this.FINISHED_STATUS
											? 'PRONTO'
											: 'PENDENTE'
									attendance.status =
										attendance.status ===
										this.FINISHED_STATUS
											? 'ready'
											: 'pending'
									return attendance
								}
							)
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			SelectAttendance(attendance) {
				this.selected_attendance_id = attendance.id

				window.jQuery('#modal-attendance').modal('show')
			},
			ShowTimeline(attendance) {
				this.timeline_data = {
					patient: {},
					logs: [],
					attendance_id: null,
				}

				if (attendance?.logs?.length) {
					this.timeline_data.logs = attendance.logs
					this.timeline_data.patient = attendance.patient
					this.timeline_data.attendance_id = attendance.id

					window.jQuery('#modal-timeline').modal('show')

					return
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Não há registros para este agendamento.',
						toast: true,
						position: 'top',
						timer: 5000,
						timerProgressBar: true,
					})
				}

				window.jQuery('#modal-timeline').modal('hide')
			},
			PrintReport() {
				const vm = this

				const fn = event => {
					if (event.data.print) {
						vm.StartLoading()

						window.removeEventListener('message', fn)

						win.close()
					}
				}

				vm.FinishLoading()

				const win = window.open(
					`${this.app_url}/consultar_laudos/visualizar/${this.report_code}?print`,
					'_blank'
				)
				win.mainWindow = window
				window.addEventListener('message', fn)
			},
			async OpenModalReport({ pdf_url }) {
				if (!pdf_url) {
					Swal.fire({
						icon: 'info',
						title: 'NÃO HÁ DOCUMENTO PARA EXIBIR',
						toast: true,
						position: 'top',
						timer: 5000,
						timerProgressBar: true,
						customClass: {
							container: 'themed',
						},
					})
					return
				}

				this.$refs.report_content.innerHTML = `<embed id='report-body' src='${pdf_url}' type='application/pdf'>`

				window
					.jQuery('#report-modal')
					.modal('show')
					.on('shown', () => {
						window.jQuery('body').addClass('modal-open')
					})
			},
			CloseModal(modal_id) {
				this.report_code = ''
				this.report_url = ''

				window
					.jQuery(modal_id)
					.modal('hide')
					.on('hidden.bs.modal', () => {
						window.jQuery('body').removeClass('modal-open')
					})
			},
		},
		async beforeMount() {
			this.is_load = true
			await this.GetPatientAttendances()
			this.is_load = false
		},
	}
</script>

<style lang="css">
	#report-modal .modal-dialog {
		max-width: 1100px !important;
	}

	#report-modal .modal-content {
		min-width: 600px;
		min-height: 600px;
	}

	#report-body {
		border: unset;
		width: 1045px;
		height: 810px;
	}

	#holder img.logo {
		width: 50% !important;
	}

	#holder .paciente div {
		line-height: 1.8rem !important;
	}

	#holder img.border-paciente {
		width: 100%;
		margin: 1rem 0 !important;
	}

	#holder .content {
		margin-top: 0.5rem;
		visibility: unset !important;
	}

	#holder .content span a.a-impressao {
		color: #000;
		cursor: pointer;
	}

	#holder .content span a.a-impressao:hover {
		color: #000 !important;
		text-decoration: underline !important;
	}

	#holder p.titulo {
		font-weight: bold;
		text-align: center;
		font-size: 1.7rem;
	}

	#holder p.subtitulo {
		font-weight: bold;
		text-align: center;
		font-size: 1.5rem;
	}

	#holder p.estrutura {
		font-weight: 700;
		font-size: 1.3rem;
	}

	#holder p.tracinho.impressao_diagnostica.conclusao,
	p.tracinho.diagnostico_diferencial_patologico {
		font-weight: bold;
	}

	#holder p.tracinho.tecnica_exame_normal,
	p.tracinho.diagnostico_diferencial_normal {
		font-weight: 400;
	}

	#holder .carimbo {
		margin-top: 3rem;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	#holder #footer {
		width: 100%;
		margin: 3rem 2rem 0 0;
		padding-top: 2px;
		border-top: 2px solid #323232;
		display: flex;
		justify-content: flex-end;
	}

	#holder #footer p {
		margin: 0;
	}

	#holder #footer p.codigo {
		background-color: #fff;
		margin: -16px 10px -2px 0 !important;
		padding: 0 8px;
		width: 304px;
	}

	.datatable-cell.status.pending {
		color: var(--priorityBackgroundColor);
	}
	.datatable-cell.status.ready {
		color: var(--successBackgroundColor);
	}
</style>
